import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface EducationItemProps {
  number: number
  item: {
    bynf: string
    rkpm: string
    xxlx: string
    xldm: string
    xxzzbq: string
    bxxz: string
    lxdm: string
    rxnf: string
    zylb: string
  }
}

const educationMap: Record<string, string> = {
  '11': '博士研究生',
  '14': '硕士研究生',
  '20': '本科',
  '30': '专科',
}

const schoolNatureMap: Record<string, string> = {
  '01': '公办',
  '02': '民办',
  '03': '中外合作办学',
}

const schoolTypeMap: Record<string, string> = {
  '01': '综合类',
  '02': '理工类',
  '03': '财经类',
  '04': '林业类',
  '05': '农业类',
  '06': '民族类',
  '07': '师范类',
  '08': '体育类',
  '09': '文法类',
  '10': '医药类',
  '11': '艺术类',
  '12': '中外合作办学',
  '98': '军事类',
  '99': '其他',
}

const learningTypeMap: Record<string, string> = {
  '01': '普通全日制',
  '02': '全日制',
  '03': '非全日制',
  '04': '脱产',
  '05': '开放教育',
  '06': '业余',
  '07': '函授',
  '08': '夜大学',
  '09': '网络教育',
  '10': '电视教育',
  '11': '远程教育',
  '99': '其他',
}

const EducationItem: React.FC<EducationItemProps> = ({ number, item }) => {
  const theme = useTheme()
  const fields = [
    { label: '学历', value: educationMap[item.xldm] || item.xldm },
    { label: '入学年份', value: item.rxnf },
    { label: '毕业年份', value: item.bynf },
    { label: '学习形式', value: learningTypeMap[item.lxdm] || item.lxdm },
    { label: '专业类别', value: item.zylb },
    { label: '学校类型', value: schoolTypeMap[item.xxlx] || item.xxlx },
    { label: '学校性质', value: schoolNatureMap[item.bxxz] || item.bxxz },
    { label: '档案排名', value: item.rkpm },
  ].filter((field) => field.value)

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          教育经历 {number}
        </Text>
        {fields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {fields.map((field) => (
              <div key={field.label} className="flex flex-col gap-1">
                <Text size="xs" c="dimmed">
                  {field.label}
                </Text>
                <Text size="sm" className="text-gray-700" fw={500}>
                  {field.value || '—'}
                </Text>
              </div>
            ))}
          </div>
        )}
      </Stack>
    </div>
  )
}

export default EducationItem
